import Vue from 'vue'
import VuePusher from 'vue-pusher'
import store from '@/lib/store'
import env from '@/lib/env'
import { jiminnyHost } from '@/helpers/region'
import { Pusher } from 'window'

let installed = false

const install = () => {
  if (installed) {
    return
  }

  installed = true

  Vue.use(VuePusher, {
    'api_key': env('PUSHER_KEY'),
    options: {
      encrypted: true,
      activityTimeout: 5000,
      pongTimeout: 5000,
      cluster: env('PUSHER_CLUSTER'),
      authEndpoint: `${jiminnyHost()}/api/v1/events/authenticate`,
      auth: {
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Authorization': `Bearer ${store.get('token')}`
        }
      }
    }
  })

  Pusher.log = console.log.bind(console)
}

export default install



// WEBPACK FOOTER //
// ./src/plugins/pusher.js